var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnSelfCare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.225,
    stroke: "#444444",
    strokeWidth: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16159 3.26562C3.81338 3.26562 3.5 3.51894 3.5 3.83559V4.2789C3.5 4.59555 3.77856 4.84886 4.12677 4.84886C4.47497 4.84886 4.75353 4.59555 4.75353 4.2789V3.86726C4.78835 3.51894 4.50979 3.26562 4.16159 3.26562Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20163 3.26562C6.85342 3.26562 6.54004 3.51894 6.54004 3.83559V4.2789C6.54004 4.59555 6.8186 4.84886 7.16681 4.84886C7.51501 4.84886 7.79357 4.59555 7.79357 4.2789V3.86726C7.82839 3.51894 7.54983 3.26562 7.20163 3.26562Z",
    fill: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58594 8.33191C4.19312 8.33191 3.49671 7.41363 3.28779 6.93866C3.21815 6.812 3.32261 6.65368 3.46189 6.59035C3.60118 6.52702 3.77528 6.62201 3.84492 6.74867C3.87974 6.78034 4.26276 7.79361 5.58594 7.79361C6.90911 7.79361 7.32696 6.78034 7.32696 6.74867C7.3966 6.62201 7.53588 6.52702 7.70998 6.59035C7.84926 6.65368 7.95372 6.78034 7.88408 6.93866C7.70998 7.4453 6.97875 8.33191 5.58594 8.33191Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSelfCare);
export default __webpack_public_path__ + "static/media/icn_self-care.ee13e751.svg";
export { ForwardRef as ReactComponent };